// extracted by mini-css-extract-plugin
export default {"detailsBox":"styles_detailsBox__ryxpb","elements":"styles_elements__CGkKf","txHash":"styles_txHash__fPe7d","planBtn":"styles_planBtn__1wI6q"};